import { Header } from '../components/Header/Header';
import { CardInfo } from '../components/CardInfo/CardInfo';
import { CardHeader } from '../components/CardHeader/CardHeader';
import { CardBody } from '../components/CardBody/CardBody';
import { Col, Row, Spinner, Button, Container, Modal, Alert } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { api } from '../services/Api';
import {useHistory, useParams} from 'react-router-dom';
import { getCurrentDateHour } from '../Utils/currentDate';
import { Input } from '../components/Input/Input';
import { useAlert } from '../contexts/AlertContext';
import {useAuth} from "../contexts/AuthenticationContext";

type ConnectionType = {
	download: string;
	id: number;
	id_contrato_servico: number;
	id_pessoa: number;
	status: string;
	tipo_conexao: string;
	upload: string;
}

export function Connection() {
	const history = useHistory();

	const { session } = useAuth();

	const { handleSetAlert } = useAlert();
	const { connectionId } = useParams<{connectionId?: string}>();

	const [connection, setConnection] = useState<ConnectionType | null>(null);
	const [statusContract, setStatusContract] = useState<string | null>(null);
	const [loadingConnection, setLoadingConnection] = useState(false);
	const [loadingModalDiagnostic, setLoadingModalDiagnostic] = useState(false);
	const [loadingModalWifi, setLoadingModalWifi] = useState(false);
	const [showModalDiagnostic, setShowModalDiagnostic] = useState(false);
	const [showModalWifi, setShowModalWifi] = useState(false);
	const [messageWifiOS, setMessageWifiOS] = useState<string | null>(null);
	const [passwordOS, setPasswordOS] = useState<string >('');
	const [usernameOS, setUsernameOS] = useState<string>('');
	const [diagnosticSinal, setDiagnosticSinal] = useState<string | null>(null);
	const [diagnosticSinalStatus, setDiagnosticSinalStatus,] = useState<boolean | null>(true);
	const [diagnosticLatencia, setDiagnosticLatencia] = useState<string | null>(null);
	const [diagnosticLatenciaStatus, setDiagnosticLatenciaStatus] = useState<boolean | null>(true);
	const [diagnosticConsumoAtual, setDiagnosticConsumoAtual] = useState<string | null>(null);
	const [diagnosticConsumoAtualStatus, setDiagnosticConsumoAtualStatus] = useState<boolean | null>(true);
	const [diagnosticResultado, setDiagnosticResultado] = useState<string | null>(null);
	const [diagnosticResultadoStatus, setDiagnosticResultadoStatus] = useState<boolean | null>(null);

	useEffect(() => {
		if(session){
			setLoadingConnection(true);

			const headers = {
				'Authorization': 'Beaser '+session.token,
				'Content-Type': 'application/json',
			};

			api.get('v1/pessoas/clientes/contratos/'+session.id_contract, { headers })
				.then((responseContract: any) => {
					api.get('v1/pessoas/clientes/contratos/'+session.id_contract+'/conexoes', { headers })
						.then((responseConnetion) => {
							responseConnetion.data.forEach((element: ConnectionType)  => {
								if (element?.id) {
									if(element?.id.toString() === connectionId) {
										setConnection(element);
									}
								} else {
									handleSetAlert({
										visible: true,
										variant: 'danger',
										message: 'Conexão não encontrada',
										timeout: 5000
									});
									history.goBack();
								}
								setLoadingConnection(false);
							});
							setStatusContract(responseContract.data.status)
						}).catch(error => {
						handleSetAlert({
							visible: true,
							variant: 'danger',
							message: error.response.data.message,
							timeout: 5000
						});
						history.goBack();
						setLoadingConnection(false);
					});
				}).catch(error => {
				handleSetAlert({
					visible: true,
					variant: 'danger',
					message: error.response.data.message,
					timeout: 5000
				});
				history.goBack();
				setLoadingConnection(false);
			});
		}
	}, [session, connectionId, history, handleSetAlert])

	function handleDianostic() {
		if(statusContract !== "Ativo" && statusContract !== "Ativo - Temporário") {
			handleSetAlert({
				visible: true,
				variant: 'danger',
				message: 'Não foi possivel executar a operação pois seu contrato não está ativo. Para mais informações entre em contato com a nossa central de atendimento no telefone '+process.env.REACT_APP_SUPERGER_TELEFONE,
				timeout: 5000
			});
		} else {
			connectionDiagnostic();
		}
	}

	function connectionDiagnostic() {
		if(session){
			setShowModalDiagnostic(true);
			setLoadingModalDiagnostic(true);

			const headers = {
				'Authorization': 'Beaser '+session.token,
				'Content-Type': 'application/json',
			};

			api.post('v1/provedor/conexao/diagnostico-completo', JSON.stringify({id: connection?.id}), { headers })
				.then((response) => {
					setDiagnosticSinal(response.data.dados.sinal)
					setDiagnosticSinalStatus(response.data.dados.sinal_status)
					setDiagnosticLatencia(response.data.dados.latencia)
					setDiagnosticLatenciaStatus(response.data.dados.latencia_status)
					setDiagnosticConsumoAtual(response.data.dados.consumo_atual)
					setDiagnosticConsumoAtualStatus(response.data.dados.consumo_atual_status)
					setDiagnosticResultado(response.data.dados.resultado)
					setDiagnosticResultadoStatus(response.data.dados.resultado_status)
					setLoadingModalDiagnostic(false);
				})
				.catch(error => {
					handleSetAlert({
						visible: true,
						variant: 'danger',
						message: error.response.data.message,
						timeout: 5000
					});
					setLoadingModalDiagnostic(false);
				});
		}
	}

	function handleDiagnosticOS() {
		if(session){
			if(!diagnosticSinalStatus || !diagnosticLatenciaStatus){

				let data = {
					"verificar_duplicado": true,
					"id_servico": 7,
					"id_contrato_servico": connection?.id_contrato_servico,
					"id_pessoa_solicitante": connection?.id_pessoa,
					"data_hora": getCurrentDateHour(),
					"descricao_solicitacao": `Diagnostico realizado pelo cliente:<br>Sinal: ${diagnosticSinal}<br>Sinal Status: ${diagnosticSinalStatus ? "Bom" : "Ruim"}<br>Latência: ${diagnosticLatencia}<br>Latência Status: ${diagnosticLatenciaStatus ? "Bom" : "Ruim"}<br>Consumo Atual: ${diagnosticConsumoAtual}<br>Consumo Atual Status: ${diagnosticConsumoAtualStatus ? "Bom" : "Ruim"}<br>Resultado: ${diagnosticResultado}`,
					"tags": [9,2]
				}

				const headers = {
					'Authorization': 'Beaser '+session?.token,
					'Content-Type': 'application/json',
				};

				api.post('v1/ordens-servico/ordens-servico/cadastrar', JSON.stringify(data), { headers })
					.then(() => {
						handleSetAlert({
							visible: true,
							variant: 'success',
							message: "O seu chamado foi aberto e em breve um dos nossos técnicos irá entrar em contato",
							timeout: 5000
						});
						setShowModalDiagnostic(false);
					})
					.catch(() => {
						handleSetAlert({
							visible: true,
							variant: 'danger',
							message: "Não foi possivel executar a operação. Para mais informações entre em contato com a nossa central de atendimento no telefone: "+process.env.REACT_APP_SUPERGER_TELEFONE,
							timeout: 5000
						});
						setShowModalDiagnostic(false);
					});
			}
		}
	}

	function handleWifi() {
		if(statusContract !== "Ativo" && statusContract !== "Ativo - Temporário") {
			handleSetAlert({
				visible: true,
				variant: 'danger',
				message: 'Não foi possivel executar a operação pois seu contrato não está ativo. Para mais informações entre em contato com a nossa central de atendimento no telefone '+process.env.REACT_APP_SUPERGER_TELEFONE,
				timeout: 5000
			});
		} else {
			setShowModalWifi(true);
		}
	}

	function handleWifiOS() {
		if(session){
			if(passwordOS){
				setLoadingModalWifi(true);

				let data = {
					"verificar_duplicado": true,
					"id_servico": 7,
					"id_contrato_servico": connection?.id_contrato_servico,
					"id_pessoa_solicitante": connection?.id_pessoa,
					"data_hora": getCurrentDateHour(),
					"descricao_solicitacao": "Solicitação de troca de senha / ssid realizado pelo cliente:<br>Nome do Wifi: "+usernameOS+"<br>Senha do Wifi: "+passwordOS,
					"tags": [9,10]
				}

				const headers = {
					'Authorization': 'Beaser '+session?.token,
					'Content-Type': 'application/json',
				};

				api.post('v1/ordens-servico/ordens-servico/cadastrar', JSON.stringify(data), { headers })
					.then(() => {
						handleSetAlert({
							visible: true,
							variant: 'success',
							message: "A sua solicitação de alterar a senha do wifi foi aberta e em breve um dos nossos técnicos irá entrar em contato",
							timeout: 5000
						});
						setShowModalWifi(false);
						setLoadingModalWifi(false);
					}).catch(() => {
					handleSetAlert({
						visible: true,
						variant: 'danger',
						message: "Não foi possivel executar a operação. Para mais informações entre em contato com a nossa central de atendimento no telefone: "+process.env.REACT_APP_SUPERGER_TELEFONE,
						timeout: 5000
					});
					setShowModalWifi(false);
					setLoadingModalWifi(false);
				});
			} else {
				handleSetAlert({
					visible: true,
					variant: 'danger',
					message: "É obrigatório preencher a senha",
					timeout: 5000
				});
			}
		}
	}

	return(
		<>
			<Header />
			<Container>
				<Row className="m-3">
					<Col md={6} className="d-flex p-0">
						<h3 className="title-page d-flex">
							<Button variant={""} className="d-flex shadow-none p-0" onClick={() => {history.goBack()}}>
								<span className="material-icons title-icon">keyboard_arrow_left</span>
							</Button>
							<span className="material-icons title-icon">wifi</span>
							Conexão
						</h3>
					</Col>
				</Row>
				<Row>
					<Row className="m-card">
						<Col md={12} className="d-flex justify-content-center">
							<CardInfo variant="w-100">
								<CardHeader variant="text-center card-header-info">
									<div className="d-flex align-items-center">
										<span className="material-icons title-icon">info</span>
										Informações
									</div>
								</CardHeader>
								<CardBody>
									<Row className="d-flex m-0">
										{loadingConnection && <div className="justify-content-center align-items-center d-flex p-2">
											<Spinner animation="border" role="status"/>
										</div>
										}
										{!loadingConnection && <Col md={12}>
											<p><b>Velocidade de Download: </b>{connection?.download}</p>
											<p><b>Velocidade de Upload: </b>{connection?.upload}</p>
											<p><b>Tipo de Conexão: </b>{connection?.tipo_conexao}</p>
											<p><b>Status: </b>{connection?.status}</p>
										</Col>
										}
									</Row>
								</CardBody>
							</CardInfo>
						</Col>
					</Row>
					<Row className="m-card">
						<Col md={12} className="d-flex justify-content-center">
							<CardInfo variant="w-100">
								<CardHeader variant="text-center card-header-info">
									<div className="d-flex align-items-center">
										<span className="material-icons title-icon">build</span>
										Ferramentas
									</div>
								</CardHeader>
								<CardBody>
									<Row className="d-flex m-0">
										{loadingConnection && <div className="justify-content-center align-items-center d-flex p-2">
											<Spinner animation="border" role="status"/>
										</div>
										}
										{!loadingConnection && <div>
											<Row>
												<Col md={8} sm={8} xs={8}>
													<p className="mb-1">Diagnóstico Rápido</p>
													<p className="color-gray">Está operação irá avaliar sua conexão para encontrar possíveis problemas</p>
												</Col>
												<Col md={4} sm={4} xs={4} className="align-self-center text-center d-grid p-2">
													<Button variant="light" onClick={() => handleDianostic()}>Executar</Button>
												</Col>
											</Row>
											<Row>
												<Col md={12} sm={12} xs={12}>
													<hr/>
												</Col>
											</Row>
											<Row>
												<Col md={8} sm={8} xs={8}>
													<p className="mb-1">Alterar a senha do Wifi</p>
													<p className="color-gray">Está operação irá alterar a senha do Wifi desta conexão</p>
												</Col>
												<Col md={4} sm={4} xs={4} className="align-self-center text-center d-grid p-2">
													<Button variant="light" onClick={() => handleWifi()}>Executar</Button>
												</Col>
											</Row>
										</div>
										}
									</Row>
								</CardBody>
							</CardInfo>
						</Col>
					</Row>
				</Row>
			</Container>

			<Modal show={showModalDiagnostic} onHide={() => {return false}} aria-labelledby="contained-modal-title-vcenter" centered>
				<Modal.Header className="justify-content-center border-bottom-0">
					<Modal.Title id="contained-modal-title-vcenter">
						Diagnóstico Rápido
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="show-grid">
					<Container>
						{loadingModalDiagnostic && <div className="justify-content-center align-items-center text-center p-2">
							<Spinner animation="border" role="status"/>
							<p className="mt-4">Executando operação, aguarde um momento</p>
						</div>
						}
						{!loadingModalDiagnostic && <div>
							<Row>
								<Alert className="d-flex" variant={diagnosticSinalStatus ? "primary" : "warning"}>
									<Col md={2} className="justify-content-center align-items-center d-flex">
										<span className="material-icons alert-icon">{diagnosticSinalStatus ? "check" : "error"}</span>
									</Col>
									<Col md={10} className="align-items-center d-flex">
										<p className="p-0 m-0 color-white">Avaliação do Sinal<br/>{diagnosticSinal}</p>
									</Col>
								</Alert>
							</Row>
							<Row>
								<Alert className="d-flex" variant={diagnosticLatenciaStatus ? "primary" : "warning"}>
									<Col md={2} className="justify-content-center align-items-center d-flex">
										<span className="material-icons alert-icon">{diagnosticLatenciaStatus ? "check" : "error"}</span>
									</Col>
									<Col md={10} className="align-items-center d-flex">
										<p className="p-0 m-0 color-white">Avaliação da Latência<br/>{diagnosticLatencia}</p>
									</Col>
								</Alert>
							</Row>
							<Row>
								<Alert className="d-flex" variant={diagnosticConsumoAtualStatus ? "primary" : "warning"}>
									<Col md={2} className="justify-content-center align-items-center d-flex">
										<span className="material-icons alert-icon">{diagnosticConsumoAtualStatus ? "check" : "error"}</span>
									</Col>
									<Col md={10} className="align-items-center d-flex">
										<p className="p-0 m-0 color-white">Avaliação do Consumo Atual<br/>{diagnosticConsumoAtual}</p>
									</Col>
								</Alert>
							</Row>
							<Row>
								<Alert className="d-flex" variant={diagnosticResultadoStatus ? "success" : "warning"}>
									<Col md={2} className="justify-content-center align-items-center d-flex">
										<span className="material-icons alert-icon">{diagnosticResultadoStatus ? "check" : "error"}</span>
									</Col>
									<Col md={10} className="align-items-center d-flex">
										<p className="p-0 m-0 color-white">{diagnosticResultado}</p>
									</Col>
								</Alert>
							</Row>
						</div>
						}
					</Container>
				</Modal.Body>
				{!loadingModalDiagnostic && <Modal.Footer className="border-top-0">
					<Button variant="light" onClick={() => {setShowModalDiagnostic(false);}}>Fechar</Button>
					{(!diagnosticSinalStatus || !diagnosticLatenciaStatus) &&
						<Button variant="primary" onClick={() => handleDiagnosticOS()}>Abrir Chamado</Button>
					}
				</Modal.Footer>}
			</Modal>

			<Modal show={showModalWifi} onHide={() => {return false}} aria-labelledby="contained-modal-title-vcenter" centered>
				<Modal.Header className="justify-content-center border-bottom-0">
					<Modal.Title id="contained-modal-title-vcenter">
						Alterar Senha do Wifi
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="show-grid">
					<Container>
						{loadingModalWifi && <div className="justify-content-center align-items-center text-center p-2">
							<Spinner animation="border" role="status"/>
							<p className="mt-4">Executando operação, aguarde um momento</p>
						</div>
						}
						{!loadingModalWifi && <div>
							<Col md={12}>
								<div className="d-flex justify-content-center w-100 align-items-center flex-column">
									<div className="w-100">
										<Input
											icon="wifi"
											type="text"
											placeholder="Digite o novo nome (Opcional)"
											onChange={value => setUsernameOS(value.target.value)}
											value={usernameOS}
										/>
									</div>
									<div className="pt-3 w-100">
										<Input
											icon="lock"
											type="text"
											placeholder="Digite a nova senha"
											onChange={value => setPasswordOS(value.target.value)}
											value={passwordOS}
										/>
									</div>
								</div>
							</Col>
						</div>
						}
					</Container>
				</Modal.Body>
				{!loadingModalWifi  && <Modal.Footer className="border-top-0">
					<Button variant="light" onClick={() => {setShowModalWifi(false); setMessageWifiOS(null);}}>Fechar</Button>
					{!messageWifiOS && <Button variant="primary" onClick={() => handleWifiOS()}>Solicitar</Button>}
				</Modal.Footer>}
			</Modal>
		</>
	);
}
